import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

const RowsLog = (props: any) => {
  const dataRow = props.item;

  return (
    <TableRow
      hover
      sx={{
        '&:last-child td, &:last-child th': { border: 0 }
      }}
    >
      <TableCell>{dataRow.emailtime}</TableCell>
      <TableCell>{dataRow.reservetype}</TableCell>
      <TableCell>{dataRow.patientno}</TableCell>
      <TableCell>{dataRow.patientname}</TableCell>
      <TableCell>{dataRow.email}</TableCell>
      <TableCell>{dataRow.result}</TableCell>
    </TableRow>
  );
};

export default RowsLog;
